import { z } from "zod";
import { yearSchema } from "./util";

export const historyEventSchema = z.object({
	id: z.string().transform((id) => parseInt(id)),
	name: z.string(),
	detail_name: z.string(),
	year: yearSchema,
	date: z.object({
		day: z.string().transform((day) => parseInt(day)),
		month: z.string().transform((month) => parseInt(month)),
		monthName: z.string(),
		dayOfWeek: z.string(),
		year: yearSchema,
		format_day_month: z.union([
			z.object({
				name: z.string(),
				declensions: z.array(z.string()),
			}),
			z.null(),
		]),
	}),
	pic_big: z.union([z.string(), z.null()]),
	pic_mini: z.union([z.string(), z.null()]),
	images: z.array(z.string()),
	detail_text: z.string(),
});
export const historyEventsSchema = z.array(historyEventSchema);

export type HistoryEventType = z.infer<typeof historyEventSchema>;
